// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// import { BrowserRouter } from "react-router-dom";
// import { Provider } from "react-redux";

// import {configureStore} from "./store/store";

// ReactDOM.render(
//   <Provider store={configureStore({})}>
//     <React.Fragment>
//       <BrowserRouter>
//         <App />
//       </BrowserRouter>
//     </React.Fragment>
//   </Provider>,
//   document.getElementById('root')
// );
// reportWebVitals();

import React from 'react';
import ReactDOM from 'react-dom/client'; // Import from 'react-dom/client' instead of 'react-dom'
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "./store/store";

// Create the root element for React 18
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={configureStore({})}>
    <React.Fragment>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

reportWebVitals();
